export const FormatLogUser = (data: any) => {
  if (!data?.id_user) {
    return {
      name: "Sistema",
      description: "Ação do sistema",
    };
  }

  return {
    name: data.name_user || `Usuário ${data.id_user}`,
    description: `ID do usuário: ${data.id_user}`,
  };
};